import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';


import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { AmortFormComponent } from './amort-form/amort-form.component';
import { AmortTableComponent } from './amort-table/amort-table.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const amortRoutes: Routes = [
  { path: '', component: AmortTableComponent, children: [
    { path: 'Amortization-Table', component: AmortTableComponent },
  ] },

  { path: 'not-found', component: PageNotFoundComponent },
  { path: '**', redirectTo: '/not-found' }
];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    AmortFormComponent,
    AmortTableComponent,
    PageNotFoundComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    // ChartsModule,
    RouterModule.forRoot(amortRoutes)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/IT-Projects/Projects/amortization/amortization-v03.1.1/src/app/app.module.ts